import styled from "styled-components";

export const StyledPasswordContainer = styled.div`
  position: relative;

  input {
    padding-right: 60px;
  }
`;

export const StyledEyeIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
`;

export const StyledPasswordRequirementsContainer = styled.div`
  margin-top: 10px;
`;
